"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailRegex = exports.BODY_CLASS_NAME = void 0;
exports.BODY_CLASS_NAME = 'feesable-widget-body';
exports.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
